import { createReducer, on } from '@ngrx/store';
import { 
  TAX_FIND_SUCCESS,
  TAX_FAILED,
  TAX_UPDATE_LOADING,
  TAX_UPDATE_ID
 } from '../actions'
import { Tax } from '@core/models';
 
export interface TaxState {
  loading: boolean;
  taxList: Tax[] | null;
  error: string | null;
  taxId: string | null;
}

const initialState: TaxState = {
  loading: false,
  taxList: null,
  taxId: null,
  error: null,
}

export const taxReducer = createReducer(
  initialState,
  on(TAX_FIND_SUCCESS, (state, { tax }) => ({ ...state, taxList: tax })),
  on(TAX_UPDATE_ID, (state, { taxId }) => ({ ...state, taxId })),
  on(TAX_FAILED, (state, { error }) => ({ ...state, error })),
  on(TAX_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
);
